/**
 * NameModal - Native Auth (Teable Integrated)
 */

const NameModal = {
    element: null,
    mode: 'LOGIN', // 'LOGIN' or 'REGISTER'
    selectedChar: 'karakter1.png',

    show: function () {
        this.render();
    },

    hide: function () {
        if (this.element) this.element.remove();
        this.element = null;
    },

    render: function () {
        if (this.element) this.element.remove();

        const modal = document.createElement('div');
        Object.assign(modal.style, {
            position: 'fixed', top: '0', left: '0', width: '100%', height: '100%',
            background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(10px)',
            display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: '20000',
            fontFamily: "'Outfit', sans-serif"
        });

        const card = document.createElement('div');
        Object.assign(card.style, {
            background: '#1a1a1a', padding: '40px', borderRadius: '25px',
            border: '1px solid rgba(255, 215, 0, 0.2)',
            width: 'min(400px, 90%)',
            boxShadow: '0 0 50px rgba(0,0,0,0.8)',
            textAlign: 'center', position: 'relative',
            display: 'flex', flexDirection: 'column', gap: '15px'
        });

        // Close Button
        const closeBtn = document.createElement('div');
        closeBtn.innerHTML = '✕';
        Object.assign(closeBtn.style, {
            position: 'absolute', top: '20px', right: '20px',
            color: '#aaa', cursor: 'pointer', fontSize: '1.2rem'
        });
        closeBtn.onclick = () => this.hide();
        card.appendChild(closeBtn);

        // Title
        const title = document.createElement('h2');
        title.innerText = 'OYUNCU ADI';
        title.style.color = 'var(--accent-gold)';
        title.style.margin = '0 0 10px';
        card.appendChild(title);

        const subTitle = document.createElement('p');
        subTitle.innerText = 'Online oyunlara katılmak için bir isim girin.';
        subTitle.style.color = '#888';
        subTitle.style.fontSize = '0.9rem';
        subTitle.style.margin = '0 0 20px';
        card.appendChild(subTitle);

        // FORM FIELDS
        const formContainer = document.createElement('div');
        formContainer.style.display = 'flex';
        formContainer.style.flexDirection = 'column';
        formContainer.style.gap = '15px';

        // CHARACTER SELECTION (Restored & Fixed)
        const charTitle = document.createElement('p');
        charTitle.innerText = 'KARAKTER SEÇ';
        charTitle.style.color = 'var(--accent-gold)';
        charTitle.style.fontSize = '0.8rem';
        charTitle.style.fontWeight = 'bold';
        charTitle.style.margin = '10px 0 5px';
        card.appendChild(charTitle);

        const charGrid = document.createElement('div');
        Object.assign(charGrid.style, {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '10px',
            marginBottom: '15px'
        });

        const characters = ['karakter1.png', 'karakter2.png', 'karakter3.png', 'karakter4.png'];
        this.selectedChar = localStorage.getItem('playerCharacter') || 'karakter1.png';

        characters.forEach(char => {
            const charWrapper = document.createElement('div');
            Object.assign(charWrapper.style, {
                aspectRatio: '1',
                borderRadius: '12px',
                border: this.selectedChar === char ? '2px solid var(--accent-gold)' : '2px solid rgba(255,255,255,0.1)',
                background: 'rgba(255,255,255,0.05)',
                cursor: 'pointer',
                overflow: 'hidden',
                transition: '0.3s',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            });

            const img = document.createElement('img');
            img.src = new URL(`../../assets/images/characters/${char}`, import.meta.url).href;
            img.style.width = '100%';
            img.style.height = '100%';
            img.style.objectFit = 'cover';
            charWrapper.appendChild(img);

            charWrapper.onclick = () => {
                this.selectedChar = char;
                // Reset all borders
                Array.from(charGrid.children).forEach(child => {
                    child.style.borderColor = 'rgba(255,255,255,0.1)';
                });
                // Set selected border
                charWrapper.style.borderColor = 'var(--accent-gold)';
            };

            charGrid.appendChild(charWrapper);
        });
        card.appendChild(charGrid);

        // Username
        const usernameInput = document.createElement('input');
        usernameInput.type = 'text';
        usernameInput.placeholder = 'Kullanıcı Adı';
        usernameInput.maxLength = 15;
        this.styleInput(usernameInput);

        // Load existing name if any
        if (window.AuthManager && window.AuthManager.username) {
            usernameInput.value = window.AuthManager.username;
        }

        formContainer.appendChild(usernameInput);

        // Action Button
        const actionBtn = document.createElement('button');
        actionBtn.innerText = 'BAŞLA';
        Object.assign(actionBtn.style, {
            width: '100%', padding: '15px', borderRadius: '12px',
            border: 'none',
            background: 'var(--accent-gold)',
            color: '#000', fontWeight: 'bold', fontSize: '1.2rem',
            cursor: 'pointer', transition: '0.3s', marginTop: '10px'
        });

        // Error Message Area
        const errorMsg = document.createElement('p');
        errorMsg.style.color = '#e74c3c';
        errorMsg.style.fontSize = '0.9rem';
        errorMsg.style.minHeight = '1.2rem';

        actionBtn.onclick = () => {
            const user = usernameInput.value.trim();

            if (user.length < 2) {
                errorMsg.innerText = "İsim en az 2 karakter olmalıdır.";
                return;
            }

            this.handleSuccess(user);
        };

        // Enter key support
        usernameInput.onkeyup = (e) => {
            if (e.key === 'Enter') actionBtn.click();
        };

        formContainer.appendChild(actionBtn);
        formContainer.appendChild(errorMsg);
        card.appendChild(formContainer);

        modal.appendChild(card);
        document.body.appendChild(modal);
        this.element = modal;

        // Auto focus
        setTimeout(() => usernameInput.focus(), 100);

        modal.onclick = (e) => {
            if (e.target === modal) this.hide();
        };
    },

    createTab: function (text, isActive) {
        const tab = document.createElement('div');
        tab.innerText = text;
        Object.assign(tab.style, {
            cursor: 'pointer',
            paddingBottom: '5px',
            borderBottom: isActive ? '3px solid var(--accent-gold)' : '3px solid transparent',
            color: isActive ? '#fff' : '#666',
            fontWeight: 'bold',
            transition: '0.3s'
        });
        return tab;
    },

    styleInput: function (input) {
        Object.assign(input.style, {
            width: '100%', padding: '15px',
            borderRadius: '12px', border: '2px solid rgba(255, 255, 255, 0.1)',
            background: 'rgba(255,255,255,0.05)', color: '#fff',
            outline: 'none', fontSize: '1rem'
        });
        input.onfocus = () => input.style.borderColor = 'var(--accent-gold)';
        input.onblur = () => input.style.borderColor = 'rgba(255, 255, 255, 0.1)';
    },

    handleSuccess: function (username) {
        if (window.AuthManager) {
            window.AuthManager.setUsername(username);
            window.AuthManager.setCharacter(this.selectedChar || "karakter1.png");
        }
        this.hide();
        if (window.SuccessModal) {
            window.SuccessModal.show("BAŞARILI", `Hoş geldin, ${username}!`, "OYUNA DÖN");
        }
    }
};

window.NameModal = NameModal;
window.AuthModal = NameModal;
